import { readAllData, STORES } from "utility"
import { mergeUpsertOffline } from "./crud"

export async function getPatientsOffline({
  page = 1,
  limit = 20,
  filters = {},
}) {
  let patients = await readAllData(STORES.PATIENTS)

  // ✅ Bug 13 fix: fullName prioritaire — si présent, on n'applique pas nom/prenom
  if (filters.fullName) {
    const tokens = filters.fullName.toLowerCase().trim().split(/\s+/)
    patients = patients.filter((p) => {
      const fullName = (p.fullName || `${p.nom || ""} ${p.prenom || ""}`)
        .toLowerCase()
        .trim()
      return tokens.every((token) => fullName.includes(token))
    })
  } else {
    if (filters.nom) {
      patients = patients.filter((p) =>
        p.nom?.toLowerCase().includes(filters.nom.toLowerCase()),
      )
    }
    if (filters.prenom) {
      patients = patients.filter((p) =>
        p.prenom?.toLowerCase().includes(filters.prenom.toLowerCase()),
      )
    }
  }

  const getCreationDate = (p) => p.creationDate || p.createdAt

  if (filters.startCreationDate) {
    const start = new Date(filters.startCreationDate)
    start.setHours(0, 0, 0, 0)
    patients = patients.filter((p) => {
      const d = getCreationDate(p)
      return d ? new Date(d) >= start : false
    })
  }

  if (filters.endCreationDate) {
    const end = new Date(filters.endCreationDate)
    end.setHours(23, 59, 59, 999)
    patients = patients.filter((p) => {
      const d = getCreationDate(p)
      return d ? new Date(d) <= end : false
    })
  }

  const totalItems = patients.length
  const start = (page - 1) * limit
  const paginated = patients.slice(start, start + limit)

  return { data: paginated, totalItems }
}

export async function createPatientOffline(body) {
  const tempId = crypto.randomUUID()

  const nom = body.nom?.toUpperCase() || ""
  const prenom = body.prenom || ""
  const fullName = `${nom} ${prenom}`.trim()

  let age = null
  if (body.birthDate) {
    const today = new Date()
    const birth = new Date(body.birthDate)
    age = today.getFullYear() - birth.getFullYear()
    const m = today.getMonth() - birth.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--
  }

  const enrichedPatient = {
    ...body,
    id: tempId,
    fullName,
    age,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    __offline: true,
  }

  await mergeUpsertOffline(STORES.PATIENTS, enrichedPatient, {
    markOffline: true,
  })

  return enrichedPatient
}
